<template>
    <v-form>
        <div class="mb-4 text-h6">{{ $t(`please_specify_hotel_meal_and_room_types`) }}</div>
        <v-row>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.roomType"
                    :label="`${$t('room_type')}`"
                    :rules="[v => v?.length <= 256 || !v || $t('validation.max_characters', {prop: 256})]"
                    variant="outlined"
                    density="compact"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.mealType"
                    variant="outlined"
                    density="compact"
                    :label="`${$t('meal_type')}`"
                    hide-details
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    v-model="product.quantityOfRooms"
                    :label="`${$t('quantity_of_rooms')}`"
                    type="number"
                    :min="1"
                    variant="outlined"
                    density="compact"
                    hide-details
                    @change="changeQuantityOfRooms"
                />
            </v-col>
        </v-row>
    </v-form>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class OfflineServiceFormAccommodation extends Vue {
        @Prop() productType
        @Prop() tourists
        @VModel() product

        changeQuantityOfRooms() {
            this.product.quantityOfRooms = +this.product.quantityOfRooms
            if (this.product.quantityOfRooms <= 0) this.product.quantityOfRooms = 1
        }
    }

    export default OfflineServiceFormAccommodation
</script>
